// Imports
// ------
import styled, { css } from 'styled-components';
import { Section, Em, H1 } from '@tackl';

// Exports
// ------
export const Jacket = styled(Section)((props) => css``);

export const Date = styled(Em)(
	(props) => css`
		margin: 0 0 1.2rem;
	`
);

export const Title = styled(H1)((props) => css``);
